import { render, staticRenderFns } from "./StaticResourceUploader.vue?vue&type=template&id=9b40b196&"
import script from "./StaticResourceUploader.vue?vue&type=script&lang=js&"
export * from "./StaticResourceUploader.vue?vue&type=script&lang=js&"
import style0 from "./StaticResourceUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports